// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay ul.selected-vehicle[data-v-3d184c16]{display:table;margin-bottom:0;margin-left:0;padding-left:0;width:100%}#openbay ul.selected-vehicle li[data-v-3d184c16]{display:table-row}#openbay ul.selected-vehicle li span[data-v-3d184c16]{display:table-cell;padding-bottom:1rem;padding-right:1rem;width:30%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
